exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tac{\r\n     padding: 0px;\r\n     margin: 0px;\r\n     text-align: center;\r\n     font-size: 18px;\r\n     padding-top: 5px;\r\n}\r\niframe#bpc .filter-bar{\r\n     opacity: 0;\r\n}\r\n.filter-bar {\r\n    display: none!important;\r\n}\r\n.panel {\r\n    border-radius: 10px;\r\n}\r\n.rdiv{\r\n/*     min-height: 375px; */\r\n}\r\n/* xs < 768 */\r\n@media screen and (max-width: 767px) {\r\n    body {\r\n        font-size: 0.9em;\r\n    }\r\n}\r\n\r\n/* sm */\r\n@media screen and (min-width: 768px) {\r\n    body {\r\n        font-size: 1em;\r\n    }\r\n}\r\n\r\n/* md */\r\n@media screen and (min-width: 992px) {\r\n    body {\r\n        font-size: 1.2em;\r\n    }\r\n}\r\n\r\n/* lg */\r\n@media screen and (min-width: 1200px) {\r\n    body {\r\n        font-size: 1.3em;\r\n    }\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/components/reports/reports.component.css
// module id = 392
// module chunks = 1